/**
 * Supported currencies and their minor-unit precision.
 *
 * Phase 1 is THB-only (SAD §8 examples), but the type is closed rather than `string` so that
 * adding a currency is a deliberate, reviewed change rather than an accident of data entry.
 */
/** ISO-4217 codes this system accepts. */
export const CURRENCIES = ['THB'];
/**
 * Decimal places a currency is denominated in, used for wire serialization.
 *
 * Storage is always `NUMERIC(20,4)` (SAD §12) regardless — the extra scale exists so that
 * future fractional-unit currencies need no migration.
 */
const CURRENCY_DECIMAL_PLACES = {
    THB: 2,
};
/** Number of decimal places used when serializing this currency to the wire. */
export function decimalPlacesFor(currency) {
    return CURRENCY_DECIMAL_PLACES[currency];
}
/** Type guard for untrusted input. */
export function isCurrency(value) {
    return typeof value === 'string' && CURRENCIES.includes(value);
}
//# sourceMappingURL=currency.js.map